import { Label } from "app/components/Label";

export const WorkspaceLabel = ({ label }: { label?: string }) =>
  label ? (
    <Label color={label === "Free" ? "default" : "info"}>{label}</Label>
  ) : (
    ""
  );
